import type React from "react";
import { useState } from "react";
import { FiShare2 } from "react-icons/fi"; // Feather icons share icon

export const Share: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // Reset after 1.5s
    } catch (err) {
      console.error("Failed to copy URL:", err);
    }
  };

  return (
    <div className="relative inline-block">
      <button
        onClick={handleShare}
        className="p-2 rounded border bg-background text-foreground hover:bg-muted hover:text-foreground transition flex items-center gap-2"
        aria-label="Share URL"
      >
        <FiShare2 size={18} />
        <span className="hidden sm:inline">Share</span>
      </button>

      {copied && (
        <span className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded shadow">
          Copied!
        </span>
      )}
    </div>
  );
};
